import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AmChart, AmChartsService } from '@amcharts/amcharts3-angular';
import { PieChartService } from './pie.service';

@Component({
  selector: 'bidi-pie-chart',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.scss']
})
export class PieComponent implements OnChanges, OnInit, OnDestroy {
  private chart: AmChart;
  @ViewChild('pieDiv') private element: ElementRef;
  @Input() private makeChart = {};
  @Input() private chartData = [];
  @Input() chartWith = 100;
  @Input() chartHeight = 255;

  constructor(
    private AmCharts: AmChartsService,
    private chartService: PieChartService
  ) {
  }

  ngOnInit() {
    this.chartService.handleDataProvided(this.AmCharts);
    this.chart = this.AmCharts.makeChart(
      this.element.nativeElement,
      this.chartService.makeOptions(this.makeChart, this.chartData)
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.chart && this.chartData.length > 0) {
      this.AmCharts.updateChart(this.chart, () => {
        this.chart.clearLabels();
        this.chart.dataProvider = this.chart.isClickable ?
          this.chartService.generateChartData(this.chartData) : this.chartData;
        this.chart.alpha = 1;
        this.chart.validateData();
      });
    }
  }

  ngOnDestroy() {
    if (this.chart) {
      this.AmCharts.destroyChart(this.chart);
    }
  }
}
